// extracted by mini-css-extract-plugin
export default {"root":"IUNJsX62","card":"Q1Q4QWGZ","legend":"Mt3EIOku","legendItem":"aRlvE8q7","legendItemFaded":"spdSg9PF","legendTitle":"O9mAU30l","legendValue":"v1K2HcoF","empty":"xbH1y3zN"};